module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_shop_online.447996bc.png";